import PageBackBar from "@/components/PageBackBar";
import MeetYolanda from "@/components/MeetYolanda";
import Manifesto from "@/components/Manifesto";
import VoyageFeature from "@/components/VoyageFeature";
import Yoili from "@/components/Yoili";
import { useSite } from "@/Layout";

export default function FounderPage() {
  const { config } = useSite();
  return (
    <div data-testid="founder-page">
      <PageBackBar testId="founder-back-bar" />
      <MeetYolanda config={config} />
      <Manifesto />
      <VoyageFeature config={config} />
      <Yoili config={config} />
    </div>
  );
}
